import React, {useEffect, useRef, useState} from "react";

import {
    Card,
    Checkbox,
    Col,
    Collapse,
    DatePicker,
    Form,
    Input,
    InputNumber,
    Modal,
    Radio,
    RadioChangeEvent,
    Row,
    Tabs
} from 'antd';
import {AntdDivider, ContainerForm, ContainerSchedule, TextDivider} from "./styles";
import {DownCircleTwoTone, EnvironmentOutlined, HomeOutlined, PhoneOutlined, UserOutlined} from '@ant-design/icons';
import ScheduleDate, {ScheduleDateApi} from "../../models/ScheduleDate";
import Vehicle from "../../models/Vehicle";
import api from "../../service/api";
import Response from "../../models/Response";
import Address from "../../models/Address";
import ItemVacancy from "../../models/ItemVacancy";
import ScheduleDay from "../../models/ScheduleDay";
import {MaskedInput} from "antd-mask-input";
import {AppCheckbox, AppRadio} from "../../global/styles";
import TextArea from "antd/lib/input/TextArea";
import RegisterAddress from "../RegisterAddress";
import {Constants} from "../../utils/Constants";
import Link from "antd/lib/typography/Link";

interface ScheduleProps {
    cpfOrCnpj: number,
    setVacancyData: any,
    setLoadStep: any,
    historyKey: string,
    vehicleData: Vehicle,
    resetStep: any,
    formRef: any,
    secondaryColor: string,
    setEnableNext: any,
    onFormChange: (isValid: boolean) => void;
}

const Schedule: React.FC<ScheduleProps> = ({
                                               cpfOrCnpj,
                                               setVacancyData,
                                               setLoadStep,
                                               vehicleData,
                                               formRef,
                                               secondaryColor,
                                               setEnableNext,
                                               onFormChange
                                           }: ScheduleProps) => {
    const [activeKeys, setActiveKeys] = useState<string[]>([]);
    const {TabPane} = Tabs;
    const {Panel} = Collapse;
    let [attendanceForm, setAttendanceForm] = useState<string>('');
    const [addressSelected, setAddressSelected] = useState(null);
    const [itemVacancyData, setItemVacancyData] = useState<ItemVacancy | null>(null);

    const [addressToSchedule, setAddressToSchedule] = useState<Address>(vehicleData.addressDto);

    const [rangeSheduleDate, setRangeSheduleDate] = useState<ScheduleDate[]>([]);
    const [isModalNewAddressVisible, setIsModalNewAddressVisible] = useState<boolean>(false);

    const [selectedScheduleDay, setSelectedSScheduleDay] = useState<ScheduleDay | null>(null);
    const [phoneMask, setPhoneMask] = useState('000000000');
    const [justPointFixed, setJustPointFixed] = useState<boolean>();
    const [justPointResidence, setJustPointResidence] = useState<boolean>();
    const [allowRemoteSchedule, setAllowRemoteSchedule] = useState<boolean>();
    const [formPoint] = Form.useForm();
    const [formDate] = Form.useForm();
    const [newVirtualSchedule] = useState<boolean>(true);
    const [name, setName] = useState<string>('');
    const [ddd, setDdd] = useState<number | null>(null);
    const [phone, setPhone] = useState<string>('');
    const [referencePoint, setReferencePoint] = useState<string>('');
    const [isFormValid, setIsFormValid] = useState<boolean>(false);

    const [oldAddress] = useState<Address>(vehicleData.addressDto)

    const [allSchedules, setAllSchedules] = useState<ScheduleDateApi[]>([]);
    const [filteredSchedules, setFilteredSchedules] = useState<ScheduleDateApi[]>([]);
    const [schedulePeriod, setSchedulePeriod] = useState(null);
    const [dates, setDates] = useState<any>([]);
    const {RangePicker}: any = DatePicker;

    const modalShownRef  = useRef(false);

    //Quando selecionar a forma de atendimento
    const onChangeFormAttendance = ((e: RadioChangeEvent) => {
        setLoadStep(true);
        setEnableNext(false);
        setItemVacancyData(null);
        console.log('inicio - onChangeFormAttendance ');
        setAttendanceForm(e.target.value);
        findScheduled("null", e.target.value, true);
        setSchedulePeriod(null);
        console.log('fim - onChangeFormAttendance ');
    })

    useEffect(() => {
        const contactDDDFromForm = formRef.getFieldValue('contactDDD');
        const contactNumberFromForm = formRef.getFieldValue('contactNumber');
        const contactNameFromForm = formRef.getFieldValue('contactName');
        const referencePointFromForm = formRef.getFieldValue('pontoDeReferencia');

        if (contactNumberFromForm) {
            setPhone(contactNumberFromForm);
        }
        if (contactDDDFromForm) {
            setDdd(contactDDDFromForm);
        }
        if (contactNameFromForm) {
            setName(contactNameFromForm);
        }
        if (referencePointFromForm) {
            setReferencePoint(referencePointFromForm);
        }
    }, [formRef]);

    useEffect(() => {
        let isValid;
        attendanceForm === Constants.POINT_FIX ? isValid = name !== '' && ddd !== null && phone !== '' : isValid = name !== '' && ddd !== null && phone !== '' && referencePoint !== '';
        setIsFormValid(isValid);
        onFormChange(isValid);
    }, [name, ddd, phone, referencePoint, isFormValid, formRef]);

    //Quando selecionar o endereço
    const onChangeAddress = ((e: RadioChangeEvent) => {
        console.log('inicio - onChangeAddress ');
        setSchedulePeriod(null);
        if (e.target.value === 'NOVO') {
            setIsModalNewAddressVisible(true);
        } else {
            setAddressSelected(e.target.value);
            setIsModalNewAddressVisible(false);
        }
        console.log('fim - onChangeAddress ');
    })

    // Quando seleciona o período (MANHA e\ou VESPERTINO)
    const onChangePeriod = (checkedValues: (string | number | boolean)[]) => {
        const periods = checkedValues.map(value => String(value));
        // Filtra os agendamentos com base nos períodos selecionados
        const filtered = filterSchedulesByPeriod(allSchedules, periods);

        // Atualiza a tela com a lista filtrada
        setRangeSheduleDate(
            filtered.map(scheduleDate => {
                if (!Array.isArray(scheduleDate.vacancyTimeDtos)) {
                    let vacancyTimeDtos = [];
                    vacancyTimeDtos.push(scheduleDate.vacancyTimeDtos);
                    scheduleDate.vacancyTimeDtos = vacancyTimeDtos;
                }
                return scheduleDate;
            })
        )
    };

    // Verifica quando o modal é desabilitado
    useEffect(() => {
        if (addressSelected) {
            setIsModalNewAddressVisible(false);
            //Apenas quando o modal for habilitado, poderá fazer a busca dos agendamentos
            if (isModalNewAddressVisible) {
                findScheduled("null", Constants.POINT_FIX, true);
            }
        }
    }, [addressSelected])

    // Modal quando não há agendamento sem ser liberty
    const modalNotSchedule = (content: string) => {
        Modal.warning({
            title: 'Atenção',
            content: content,
            onOk: () => {
                // ao clicar em "ok" reinicia a página para o início
                window.location.reload();
            },
            okCancel: true,
            cancelText: "Alterar Endereço",
            onCancel: () => {
                // ao clicar em "Alterar Endereço" abre modal para alterar endereço e realizar uma nova chamada
                formPoint.setFieldsValue({"size": Constants.POINT_FIX});
                setAttendanceForm(Constants.POINT_FIX);
                setIsModalNewAddressVisible(true);
                // sr for suhai ou caminhão/carreta habilita tanto ponto fixo quanto domicílio
                if (vehicleData.clientNm.toUpperCase().includes(Constants.CLIENTE_LIBERA_DOMICILIO_SUHAI) ||
                    vehicleData.clientNm.toUpperCase().includes(Constants.CLIENTE_LIBERA_DOMICILIO_SURA) ||
                    Constants.TIPO_VEICULO_LIBERA_DOMICILIO.includes(vehicleData.vehicleTypeName.toUpperCase())) {
                    setJustPointResidence(false);
                    setJustPointFixed(false);
                }
                // senão habilita apenas para domícilio, dependendo do endereço essa condição pode ser alterada.
                else {
                    setJustPointResidence(false);
                    setJustPointFixed(true);
                }
                setAddressSelected(null);
            },
        });
    }

    // Modal quando for caminhão/ carreta ou suhai
    const modalSuhaiOrTruck = (content: string) => {
        Modal.warning({
            title: 'Atenção',
            content: <>{content}</>,
            onOk: () => {
                // ao clicar em "ok" reinicia a página para o início
                window.location.reload();
            },
            okCancel: true,
            cancelText: "Alterar Endereço",
            onCancel: () => {
                //  ao clicar em "Alterar Endereço" abre modal para alterar endereço e realizar uma nova chamada
                formPoint.setFieldsValue({"size": Constants.POINT_FIX});
                setAttendanceForm(Constants.POINT_FIX);
                setIsModalNewAddressVisible(true);
                setAddressSelected(null);
                setJustPointResidence(false);
                setJustPointFixed(false);
            },
        });
    }

    // Modal quando não for caminhão/ carreta ou suhai
    const modalNotSuhaiOrTruck = (content: string) => {
        Modal.warning({
            title: 'Atenção',
            content: <>{content}</>,
            okText: "Agendar em Domicílio",
            onOk: () => {
                setLoadStep(true);
                //  ao clicar em "Agendar em Domicílio" realizar uma chamada
                formPoint.setFieldsValue({"size": Constants.REMOTE_POINT});
                setAttendanceForm(Constants.REMOTE_POINT);
                findScheduled("null", Constants.REMOTE_POINT, true);
                setJustPointResidence(true);
                if (vehicleData.clientNm == Constants.YELUM_COSTUMER && (vehicleData.vehicleManufacturerName.includes(Constants.MERCEDES_BENZ_VEHICLE) || vehicleData.fnGroupId == Constants.ID_GROUP_CORPORATIVE)) {
                    setAllowRemoteSchedule(true);
                } else {
                    setAllowRemoteSchedule(false);
                }
                setAddressSelected(vehicleData.addressDto.zipCode);
            },
            okCancel: true,
            cancelText: "Alterar Endereço",
            onCancel: () => {
                //  ao clicar em "Alterar Endereço" abre modal para alterar endereço e realizar uma nova chamada
                formPoint.setFieldsValue({"size": Constants.POINT_FIX});
                setAttendanceForm(Constants.POINT_FIX);
                setIsModalNewAddressVisible(true);
                if (vehicleData.clientNm == Constants.YELUM_COSTUMER && ((vehicleData.vehicleManufacturerName.includes(Constants.MERCEDES_BENZ_VEHICLE)) || vehicleData.fnGroupId == Constants.ID_GROUP_CORPORATIVE)) {
                    setAllowRemoteSchedule(true);
                } else {
                    setAllowRemoteSchedule(false);
                }
                setJustPointFixed(true);
                setAddressSelected(null);
            },
        });
    }

    const findScheduled = async (period: string, local: string, firstFind: boolean) => {
        let dataAtual = new Date().toLocaleDateString();
        setLoadStep(true);
        // Faz chamada na API do BackEnd para trazer as datas de agendamento.
        api.get<Response<ScheduleDateApi>[]>('scheduleExternal/findAllScheduleByParameters', {
            headers: {
                dateStart: dataAtual, // DiaDeHoje
                local: local.split(' ')[0], // Ponto fixo
                dateEnd: vehicleData.serviceDateLimit, // serviceDateLimit
                cep: addressToSchedule.isNew ? addressToSchedule.zipCode : vehicleData.addressDto.zipCode, // Cep mesmo
                fnRequisitionID: vehicleData.fnRequisitionID, //Adicionado para mudança da tracker(confirmar) // ...
                newVirtualSchedule: true
            }
        }).then(response => {
            console.log('response: ' + JSON.stringify(response.data));
            console.log('---------- FIM ----------');
            /*
            * @davidsantos
            * Devido ao servidor não retornar corretamente os dados do objeto vacancyTimeDtos, uma hora volta um array outra objeto,
            * Foi feito um ajuste para que conseguíssemos interpretar o retorno errado do servidor.
            */
            let scheduleDateArray = response.data.map(schedule => {
                return schedule.data
            })
            setAllSchedules(scheduleDateArray);
            // Realiza a busca das datas dos agendamentos disponiveis, colocando-os em uma lista
            setRangeSheduleDate(
                scheduleDateArray.map(scheduleDate => {
                    if (!Array.isArray(scheduleDate.vacancyTimeDtos)) {
                        let vacancyTimeDtos = [];
                        vacancyTimeDtos.push(scheduleDate.vacancyTimeDtos);
                        scheduleDate.vacancyTimeDtos = vacancyTimeDtos;
                    }
                    return scheduleDate;
                })
            )

            // Verifica etapa por etapa se não é suhai ou caminhão/carreta e se é "FIXO" ou "DOMICILIO" (se realizar essa verificação em conjunto ocorre erro)
            if (!vehicleData.clientNm.toUpperCase().includes(Constants.CLIENTE_LIBERA_DOMICILIO_SUHAI) &&
                !vehicleData.clientNm.toUpperCase().includes(Constants.CLIENTE_LIBERA_DOMICILIO_SURA)) {
                if (!Constants.TIPO_VEICULO_LIBERA_DOMICILIO.includes(vehicleData.vehicleTypeName.toUpperCase())) {
                    // Se for "FIXO" seta apenas os agendamentos fixos
                    if (response.data[0].data.vacancyTimeDtos[0].vacancyDto.warehouseDto.fcWarehouseTypeNm === "FIXO") {
                        formPoint.setFieldsValue({"size": Constants.POINT_FIX});
                        setAttendanceForm(Constants.POINT_FIX);
                        setJustPointFixed(true);
                    }
                    // Se for "DOMICILIO" seta apenas os agendamentos domicílios
                    else if (response.data[0].data.vacancyTimeDtos[0].vacancyDto.warehouseDto.fcWarehouseTypeNm === "DOMICILIO") {

                        formPoint.setFieldsValue({"size": Constants.REMOTE_POINT});
                        setAttendanceForm(Constants.REMOTE_POINT);
                        setJustPointResidence(true);
                    }
                }
            }

            if (vehicleData.clientNm == Constants.YELUM_COSTUMER && ((vehicleData.vehicleManufacturerName.includes(Constants.MERCEDES_BENZ_VEHICLE)) || vehicleData.fnGroupId == Constants.ID_GROUP_CORPORATIVE)) {
                setAllowRemoteSchedule(true);
            } else {
                setAllowRemoteSchedule(false);
            }

            setAddressSelected(vehicleData.addressDto.zipCode);
            setLoadStep(false);
        }).catch(error => {
            let content: any = <>Não localizamos prestadores disponíveis em sua região, ou o agendamento está próximo do
                prazo final acordado para instalação. Mas não se preocupe, temos um jeito fácil e prático para
                resolvermos, basta clicar <Link
                    href={`https://api.whatsapp.com/send?phone=551140027002&text=Olá!%20Vim%20pela%20Agenda%20Virtual%20e%20não%20localizei%20vaga%20disponível.`}
                    target='_blank'> aqui </Link> e redirecionaremos você para nossa Central de agendamento
                WhatsApp 11 4002-7002. Se preferir, você também pode nos ligar pelos telefones: 4002-7002 para
                capitais e outras regiões 0800 77014 15. Aguardamos seu contato.</>;

            const client = vehicleData.clientNm;
            if (client) {
                // Verifica se o cliente é suhai, se for muda a mensagem de erro a ser mostrada.
                if (client.toUpperCase().includes(Constants.CLIENTE_LIBERA_DOMICILIO_SUHAI)) {
                    content = <>Não localizamos prestadores disponíveis em sua região, ou o agendamento está próximo do
                        prazo final acordado para instalação. Mas não se preocupe, temos um jeito fácil e prático para
                        resolvermos, basta clicar <Link
                            href={`https://api.whatsapp.com/send?phone=551140027002&text=Olá!%20Vim%20pela%20Agenda%20Virtual%20e%20não%20localizei%20vaga%20disponível.`}
                            target='_blank'> aqui </Link> e redirecionaremos você para nossa Central de agendamento
                        WhatsApp 11 4002-7002. Se preferir, você também pode nos ligar pelos telefones: 4002-7002 para
                        capitais e outras regiões 0800 77014 15. Aguardamos seu contato.</>;
                    // senão verifica se o cliente é liberty, se for muda a mensagem de erro a ser mostrada.
                } else if (client.toUpperCase().includes(Constants.CLIENTE_LIBERA_DOMICILIO_LIBERTY)) {
                    content = <>Não localizamos prestadores disponíveis em sua região, ou o agendamento está próximo do
                        prazo final acordado para instalação. Mas não se preocupe, temos um jeito fácil e prático para
                        resolvermos, basta clicar <Link
                            href={`https://api.whatsapp.com/send?phone=551140027002&text=Olá!%20Vim%20pela%20Agenda%20Virtual%20e%20não%20localizei%20vaga%20disponível.`}
                            target='_blank'> aqui </Link> e redirecionaremos você para nossa Central de agendamento
                        WhatsApp 11 4002-7002. Se preferir, você também pode nos ligar pelos telefones: 11 3003 9239
                        para capitais e outras regiões 0800 722 9239 (opção 2). Aguardamos seu contato.</>;
                    // caso não seja nenhuma dos dois clientes, exibe uma mensagem padrão.
                }
            }

            setLoadStep(false);

            // Caso seja do tipo "fixo" abre o modal "modalNotSuhaiOrTruck" (1 = fixo ; 2 = domicílio)
            if (error.config.headers.local === "1") {
                if (modalShownRef.current) return; // impede duplicação
                content = Constants.ESCOLHA_CEP_OU_DOMICILIO;
                modalNotSuhaiOrTruck(content);
            } else {
                // Se for do tipo "domiclio" e for suhai ou caminhão/carreta abre modal "modalSuhaiOrTruck"
                if (vehicleData.clientNm.toUpperCase().includes(Constants.CLIENTE_LIBERA_DOMICILIO_SUHAI)
                    || vehicleData.clientNm.toUpperCase().includes(Constants.CLIENTE_LIBERA_DOMICILIO_SURA)
                    || Constants.TIPO_VEICULO_LIBERA_DOMICILIO.includes(vehicleData.vehicleTypeName.toUpperCase())) {
                    modalSuhaiOrTruck(content);
                    // Se for do tipo "domiclio" e não for suhai ou caminhão/carreta abre modal "modalNotSchedule"
                } else {
                    modalNotSchedule(content);
                }
            }
            modalShownRef.current = true;
        });
    }

    const filterSchedulesByPeriod = (schedules: ScheduleDateApi[], selectedPeriods: string[]) => {
        if (selectedPeriods.length > 0 && schedules) {
            const schedulesFiltered: ScheduleDateApi[] = [];

            schedules.forEach(dto => {
                const listVacancyTimes = dto.vacancyTimeDtos;
                const filteredList: ScheduleDay[] = [];

                if (listVacancyTimes) {
                    // Filtra pelos períodos selecionados
                    listVacancyTimes.forEach((vacancyTimeDto: ScheduleDay) => {
                        if (selectedPeriods.includes(vacancyTimeDto.dayPeriod)) {
                            filteredList.push(vacancyTimeDto);
                        }
                    });
                }

                schedulesFiltered.push({
                    ...dto,
                    vacancyTimeDtos: filteredList,
                });
            });
            // Retorna a lista filtrada
            return schedulesFiltered;
        }

        // Se nenhum período estiver selecionado, retorna todos os agendamentos sem filtrar
        return schedules;
    };


    //Quando seleciona uma data retornada na agenda
    const onChangeScheduleDate = (e: RadioChangeEvent) => {
        setSelectedSScheduleDay(e.target.value)
        setItemVacancyData(null);
        formRef.setFieldsValue({
            'attendanceForm': attendanceForm,
            'period': e.target.value.dayPeriod,
            'clientAddress': addressToSchedule.address + ", " + addressToSchedule.number + ", " + addressToSchedule.zipCode + " - " + addressToSchedule.city + "/" + addressToSchedule.state
        });
        setLoadStep(true);

        console.log('---------- INICIO ----------');
        console.log('URL : scheduleExternal/findItemVacancy');
        console.log('cep: ' + (attendanceForm === '1 - Ponto Fixo') ? e.target.value.vacancyDto.warehouseDto.fcWarehousePostCodeNu : addressToSchedule.zipCode);
        console.log('number: ' + (attendanceForm === '1 - Ponto Fixo') ? e.target.value.vacancyDto.warehouseDto.fcWarehouseAddNu || 0 : addressToSchedule.number);
        console.log('vacancyTimeId: ' + e.target.value.fnVacancyTimeId);
        console.log('fnRequisitionID: ' + vehicleData.fnRequisitionID);
        console.log('object body:' + JSON.stringify(e.target.value));

        api.post<Response<ItemVacancy>>('scheduleExternal/findItemVacancy', e.target.value, {
            headers: {
                fnRequisitionID: vehicleData.fnRequisitionID,
                newVirtualSchedule: newVirtualSchedule
            }
        }).then(response => {
            console.log('response: ' + JSON.stringify(response.data));
            console.log('---------- FIM ----------');
            setItemVacancyData(response.data.data);
            vehicleData.addressDto = addressToSchedule;
            setLoadStep(false);
            attendanceForm === Constants.POINT_FIX ? setEnableNext(name !== '' && ddd !== null && phone !== '') : setEnableNext(name !== '' && ddd !== null && phone !== '' && referencePoint !== '');
        }).catch(error => {
            setLoadStep(false);
            Modal.warning({
                title: 'Atenção',
                content:
                    <>
                        {
                            error.response.data.errors.map((error: string) => {
                                return error;
                            })
                        }
                    </>
            })
        })
    };

    //Máscara dinamica do campo telefone numero
    const onChangePhoneNumber = (e: any) => {
        let lengthValue = 0;
        if (e.inputType === 'insertText' || e.inputType === 'deleteContentBackward') {
            lengthValue = e.unmaskedValue.length <= 8 ? e.unmaskedValue.length : e.unmaskedValue.length + e.data.length
        } else if (e.type === "paste") {
            lengthValue = e.unmaskedValue.length;
        } else if (e.type === "keypress") {
            lengthValue = e.unmaskedValue.length < 8 ? e.unmaskedValue.length : e.unmaskedValue.length + e.key.length
        }
        lengthValue === 0 ? setPhoneMask('000000000') : lengthValue <= 8 ? setPhoneMask('0000-0000') : setPhoneMask('00000-0000')
    }

    useEffect(() => {
        if (!vehicleData || !addressToSchedule) return;

        if (vehicleData.vehicleTypeName === undefined) {
            vehicleData.vehicleTypeName = "";
        }

        if (itemVacancyData) {
            itemVacancyData.addressDto = addressToSchedule;
            itemVacancyData.itemSelected = itemVacancyData.vacancyTimeDto;
        }

        const isSuhai = vehicleData.clientNm.toUpperCase().includes(Constants.CLIENTE_LIBERA_DOMICILIO_SUHAI);
        const isSura = vehicleData.clientNm.toUpperCase().includes(Constants.CLIENTE_LIBERA_DOMICILIO_SURA);

        const isVeiculoEspecial = Array.isArray(Constants.TIPO_VEICULO_LIBERA_DOMICILIO)
            ? Constants.TIPO_VEICULO_LIBERA_DOMICILIO.includes(vehicleData.vehicleTypeName.toUpperCase())
            : false;

        const liberaDomicilio = isSuhai || isSura || isVeiculoEspecial;

        if (liberaDomicilio) {
            setJustPointFixed(false);
            setJustPointResidence(false);
            formPoint.setFieldsValue({ size: Constants.POINT_FIX });
            setAttendanceForm(Constants.POINT_FIX);

            setTimeout(() => {
                findScheduled("null", Constants.POINT_FIX, true);
            }, 0);

            return;
        }

        if (vehicleData.scheduleRemote) {
            formPoint.setFieldsValue({ size: Constants.POINT_FIX });
            setJustPointFixed(true);
            setAttendanceForm(Constants.POINT_FIX);

            setTimeout(() => {
                findScheduled("null", Constants.POINT_FIX, true);
            }, 0);

            return;
        }

        setAddressSelected(vehicleData.addressDto.zipCode);

        setTimeout(() => {
            findScheduled("null", Constants.POINT_FIX, true);
        }, 0);

    }, [
        vehicleData.clientNm,
        vehicleData.vehicleTypeName,
        vehicleData.scheduleRemote,
        addressToSchedule
    ]);

    setVacancyData(itemVacancyData);

    const togglePanel = (warehouseName: string) => {
        setActiveKeys((prevKeys) =>
            prevKeys.includes(warehouseName)
                ? prevKeys.filter((key) => key !== warehouseName)
                : [...prevKeys, warehouseName]
        );
    };

    // Agrupa os horários por armazém
    const groupByWarehouse = (vacancyTimeDtos: ScheduleDay[]) => {
        const grouped = vacancyTimeDtos.reduce<Record<string, ScheduleDay[]>>(
            (acc, scheduleDay) => {
                const warehouseName = scheduleDay.vacancyDto.warehouseDto.fcWarehouseNm;
                if (!acc[warehouseName]) {
                    acc[warehouseName] = [];
                }
                acc[warehouseName].push(scheduleDay);
                return acc;
            },
            {}
        );
        return grouped;
    };

    return (
        <ContainerForm>

            <ContainerSchedule style={{height: '100%'}}>

                <AntdDivider orientation="center" plain><TextDivider> 1. Selecione a forma de
                    Atendimento </TextDivider></AntdDivider>
                <Form
                    name="wrap"
                    labelCol={{span: 4}}
                    labelAlign="left"
                    labelWrap
                    wrapperCol={{flex: 1}}
                    colon={false}
                    form={formPoint}
                >
                    <Form.Item name="size">
                        <Radio.Group onChange={onChangeFormAttendance} value={attendanceForm} className="custom-radio">
                            <AppRadio color={"#DC3644"}
                                      disabled={justPointResidence && !allowRemoteSchedule}
                                      checked={justPointFixed && attendanceForm === Constants.POINT_FIX}
                                      value={Constants.POINT_FIX}>Comparecer na instaladora</AppRadio>
                            <AppRadio color={"#DC3644"}
                                      checked={justPointResidence && attendanceForm === Constants.REMOTE_POINT}
                                      disabled={justPointFixed && !allowRemoteSchedule} value={Constants.REMOTE_POINT}>Atendimento em
                                Domicilio</AppRadio>
                        </Radio.Group>
                    </Form.Item>
                </Form>

                {attendanceForm &&
                    <>
                        <AntdDivider orientation="center" plain>
                            <TextDivider>
                                2. Selecione o endereço do cliente/segurado
                                {attendanceForm === '1 - Ponto Fixo' &&
                                    '- para análise dos endereços das instaladoras mais próximas'
                                }
                            </TextDivider>
                        </AntdDivider>
                        <Form
                            name="wrap"
                            labelCol={{span: 4}}
                            wrapperCol={{flex: 1}}
                            labelAlign="left"
                            labelWrap
                            colon={false}
                        >
                            <Form.Item>
                                <Radio.Group onChange={onChangeAddress} value={addressSelected}
                                             className="custom-radio"
                                             style={{width: '100%'}}>
                                    <AppRadio color={"#DC3644"}
                                              value={addressToSchedule.zipCode}><HomeOutlined/> {
                                        addressToSchedule.address} {addressToSchedule.number}, {addressToSchedule.zipCode} - {addressToSchedule.city}
                                        /{addressToSchedule.state}
                                    </AppRadio>
                                </Radio.Group>
                            </Form.Item>
                        </Form>
                        {}
                        <RegisterAddress isOpen={isModalNewAddressVisible} cpfOrCnpj={cpfOrCnpj}
                                         vehicleData={vehicleData} formRef={formRef}
                                         setAddressSelected={setAddressSelected}
                                         setAddressToSchedule={setAddressToSchedule}
                        />
                    </>
                }

                {addressSelected &&
                    <>
                        <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}}>
                            <Col className="gutter-row" span={24}>
                                <AntdDivider orientation="center" plain><TextDivider> 3. Selecione o período para
                                    consultar datas disponíveis </TextDivider></AntdDivider>
                            </Col>
                        </Row>
                        <Form
                            name="wrap"
                            labelCol={{span: 4}}
                            wrapperCol={{flex: 1}}
                            labelAlign="left"
                            labelWrap
                            colon={false}
                        >
                            <Form.Item name="item_period">
                                <Checkbox.Group onChange={onChangePeriod}>
                                    <AppCheckbox color={secondaryColor} value="MANHA">Manhã</AppCheckbox>
                                    <AppCheckbox color={secondaryColor} value="TARDE">Tarde</AppCheckbox>
                                </Checkbox.Group>
                            </Form.Item>
                        </Form>

                        <AntdDivider orientation="center" plain></AntdDivider>
                    </>

                }

                {(attendanceForm === '1 - Ponto Fixo' &&
                    rangeSheduleDate && (
                        <Tabs defaultActiveKey="1" tabPosition="top" moreIcon={<DownCircleTwoTone/>}>
                            {rangeSheduleDate.map((scheduleDate, key) => {
                                // Agrupa os horários por armazém
                                const groupedSchedules = groupByWarehouse(scheduleDate.vacancyTimeDtos);

                                return (
                                    <TabPane
                                        tab={<span style={{
                                            fontWeight: selectedScheduleDay?.dayPeriod === scheduleDate.date ? 'bold' : 'normal',
                                            fontSize: selectedScheduleDay?.dayPeriod === scheduleDate.date ? '18px' : '14px',
                                        }}>{scheduleDate.date}</span>}
                                        key={key}>
                                        {Object.keys(groupedSchedules).map((warehouseName, index) => (
                                            <Collapse
                                                key={index}
                                                activeKey={activeKeys}
                                                onChange={() => togglePanel(warehouseName)}
                                            >
                                                <Panel
                                                    header={
                                                        <div style={{fontWeight: 'bold', cursor: 'pointer'}}>
                                                            <HomeOutlined/> {`${warehouseName} - ${groupedSchedules[warehouseName][0].vacancyDto.warehouseDto.fcWarehouseAddressNm}, ${groupedSchedules[warehouseName][0].vacancyDto.warehouseDto.fcWarehouseAddNu || 'Sem número'}, ${groupedSchedules[warehouseName][0].vacancyDto.warehouseDto.fcWarehousePostCodeNu} - ${groupedSchedules[warehouseName][0].vacancyDto.warehouseDto.cityDto.fcCityDs}/${addressToSchedule.state}`}
                                                        </div>
                                                    }
                                                    key={warehouseName}
                                                >
                                                    <Radio.Group
                                                        className="custom-radio"
                                                        style={{width: '100%'}}
                                                        onChange={onChangeScheduleDate}
                                                        value={selectedScheduleDay}
                                                    >
                                                        {/* Usamos um Set para evitar duplicação de horários */}
                                                        {Array.from(
                                                            new Set(
                                                                groupedSchedules[warehouseName]
                                                                    .sort((a, b) => {
                                                                        const dateA = new Date(
                                                                            a.fdVacTimeIniDt.split('/').reverse().join('-')
                                                                        ).getTime();
                                                                        const dateB = new Date(
                                                                            b.fdVacTimeIniDt.split('/').reverse().join('-')
                                                                        ).getTime();
                                                                        return dateA - dateB;
                                                                    })
                                                                    .map((scheduleDay) => `${scheduleDay.timeInit}-${scheduleDay.timeEnd}`)
                                                            )
                                                        ).map((time, index) => {
                                                            const [timeInit, timeEnd] = time.split('-');
                                                            const scheduleDay = groupedSchedules[warehouseName].find(
                                                                (s) => s.timeInit === timeInit && s.timeEnd === timeEnd
                                                            );

                                                            return (
                                                                <Card
                                                                    key={index}
                                                                    style={{
                                                                        fontWeight:
                                                                            selectedScheduleDay?.timeInit === scheduleDay?.timeInit
                                                                                ? 'bold'
                                                                                : 'normal'
                                                                    }}
                                                                >
                                                                    <Row
                                                                        gutter={{xs: 8, sm: 16, md: 24, lg: 32}}
                                                                        style={{
                                                                            marginLeft: '-16px',
                                                                            marginRight: '-16px',
                                                                            textAlign: 'center',
                                                                            alignItems: 'center',
                                                                        }}
                                                                    >
                                                                        <Col xl={2} xs={4} sm={2}>
                                                                            <Radio value={scheduleDay}/>
                                                                        </Col>

                                                                        <Col xl={2} xs={12} sm={4}>
                                                                            Início: {scheduleDay?.timeInit}
                                                                        </Col>
                                                                        <Col xl={2} xs={12} sm={4}>
                                                                            Fim: {scheduleDay?.timeEnd}
                                                                        </Col>

                                                                        <Col xl={3} xs={24} sm={12}
                                                                             style={{textAlign: 'center'}}>
                                                                            {scheduleDay?.dayPeriod}
                                                                        </Col>
                                                                    </Row>
                                                                </Card>
                                                            );
                                                        })}
                                                    </Radio.Group>
                                                </Panel>
                                            </Collapse>
                                        ))}
                                    </TabPane>
                                );
                            })}
                        </Tabs>
                    )
                )}

                {(attendanceForm === Constants.REMOTE_POINT) && rangeSheduleDate &&
                    <Tabs defaultActiveKey="1" tabPosition={'top'} moreIcon={<DownCircleTwoTone/>}>
                        {rangeSheduleDate.map((scheduleDate, key) => (
                            <TabPane tab={`${scheduleDate.date}`} key={key}>
                                <Radio.Group className="custom-radio"
                                             style={{width: '100%', backgroundColor: 'white'}}
                                             onChange={onChangeScheduleDate}
                                             value={selectedScheduleDay}>
                                    {scheduleDate.vacancyTimeDtos
                                        .filter((scheduleDay, index, self) =>
                                            index === self.findIndex((t) => t.dayPeriod === scheduleDay.dayPeriod) // Remove duplicados
                                        )
                                        .map((scheduleDay, key) => (
                                                <Card
                                                    style={{
                                                        width: '100%',
                                                        backgroundColor: 'white',
                                                        fontWeight: 'normal'
                                                    }}
                                                    key={key}
                                                >
                                                    <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} style={{
                                                        marginLeft: '-16px',
                                                        marginRight: '-16px',
                                                        textAlign: 'center',
                                                        alignItems: 'center'
                                                    }}>
                                                        <Col xl={2} xs={4} sm={2}>
                                                            <AppRadio color={"#DC3644"} value={scheduleDay}
                                                                      checked={false}></AppRadio>
                                                        </Col>

                                                        <Col xl={3} xs={24} sm={12}
                                                             style={{alignContent: 'center', textAlign: 'center'}}>
                                                            Período: {scheduleDay.dayPeriod}
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            )
                                        )
                                    }
                                </Radio.Group>
                            </TabPane>
                        ))}
                    </Tabs>
                }

                {itemVacancyData &&
                    <>
                        <AntdDivider orientation="center" plain><TextDivider>4. Dados para
                            Contato </TextDivider></AntdDivider>
                        <Form
                            form={formRef}
                            name="wrap"
                            wrapperCol={{flex: 1}}
                            labelAlign="left"
                            labelWrap
                            colon={false}
                            layout="vertical"
                        >
                            <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align="middle">
                                <Form.Item name="attendanceForm" hidden={true}>
                                    <Input/>
                                </Form.Item>
                                <Form.Item name="period" hidden={true}>
                                    <Input/>
                                </Form.Item>
                                <Form.Item name="clientAddress" hidden={true}>
                                    <Input/>
                                </Form.Item>
                                <Col xl={attendanceForm === '2 - Domicílio' ? 8 : 16} xs={24} sm={13}>
                                    <Form.Item label="Nome" name="contactName"
                                               rules={[{required: true, message: 'Informe o nome para contato'}]}>
                                        <Input value={name} onChange={(e) => setName(e.target.value)}
                                               addonBefore={<UserOutlined/>}
                                               placeholder="Nome para contato"/>
                                    </Form.Item>
                                </Col>
                                <Col xl={3} xs={9} sm={4}>
                                    <Form.Item label="DDD" name="contactDDD" rules={[{required: true, message: 'DDD'}]}>
                                        <InputNumber
                                            value={ddd}
                                            onChange={(value) => setDdd(value)}
                                            placeholder="DDD"
                                            min={11}
                                            max={99}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={5} xs={15} sm={7}>
                                    <Form.Item
                                        label="Telefone"
                                        name="contactNumber"
                                        rules={[
                                            {required: true, message: 'Informe o telefone'},
                                            {min: 8, message: 'Telefone inválido'}
                                        ]}
                                    >
                                        <MaskedInput
                                            onChange={(e) => {
                                                onChangePhoneNumber(e);
                                                setPhone(e.target.value);
                                            }}
                                            mask={phoneMask}
                                            maskOptions={{lazy: true}}
                                            addonBefore={<PhoneOutlined/>}
                                            placeholder="Número"
                                            value={phone}
                                        />
                                    </Form.Item>
                                </Col>

                                {
                                    attendanceForm === '2 - Domicílio' &&
                                    <Col xl={8} xs={24} sm={24}>
                                        <Form.Item name="pontoDeReferencia" label="Ponto de Referência"
                                                   rules={[{
                                                       required: true,
                                                       message: 'Informe o ponto de referência'
                                                   }]}>
                                            <Input addonBefore={<EnvironmentOutlined/>}
                                                   value={referencePoint}
                                                   onChange={(e) => setReferencePoint(e.target.value)}
                                                   placeholder="Ponto de Referência"/>
                                        </Form.Item>
                                    </Col>
                                }
                            </Row>
                            <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align="middle">
                                <Col xl={24} xs={24} sm={24}>
                                    <Form.Item name="obsReserveExternal" label="Observações">
                                        <TextArea cols={2}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </>
                }


            </ContainerSchedule>

        </ContainerForm>
    )
}

export default Schedule;
